module.exports = __webpack_public_path__ + "static/media/plugOff_118.4e030a68.png";